module.exports = __webpack_public_path__ + "img/AP_logo_esteso_docente.78730c9a.svg";